export default {
    title: "",
    unavailable: "Ten produkt nie jest już dostępny."
}